import { QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';

/** *
 * this configuration holds no baseUrl, so basically it can combine method requests from different services,
 * the method config path should be configured to contain the service base url
 */

export const RawHttpServiceConfig = {
  name: 'RawHttpApiConfig',
  baseUrl: '',
  defaultHttpMethod: 'get',
  defaultQueryConfigType: QueryConfigTypes.DYNAMIC_DATA
};
export const RawHttpApiConfig = {
  listTransferIns: {
    service: RawHttpServiceConfig,
    name: 'listTransferIns',
    path: '/_api/domain-delivery/v1/transferRequests'
  },
  userDetails: {
    service: RawHttpServiceConfig,
    name: 'userDetails',
    path: '/_api/wix-html-login-webapp/user/getUserDetails',
    responseTransform: rawResponse => {
      return rawResponse.payload;
    }
  }
};
//# sourceMappingURL=RawHttpApiConfig.js.map